export const workOrderRowCells = [
    [
        {   
            className: 'row-cell product-code',
            placeholder: 'Ürün Kodu',
            id: 'work-order-product-code', 
            name: 'productCode',
            value: 'productCode',
            datePicker: false,
        }
    ], 
    [ 
        {
            className: '',
            placeholder: 'Ür. Tarihi',
            id: 'work-order-frame-date',
            name: 'frameDate',
            value: 'frameDate',
            datePicker: true,
        }, 
        {
            className: '',
            placeholder: 'R. Kod No',
            id: 'work-order-frame-roll-code',
            name: 'frameRollCode',
            value: 'frameRollCode',
        }
    ], 
    [ 
        {
            className: '',
            placeholder: '',
            id: 'work-order-middle-traverse-date',
            name: 'middleTraverseDate',
            value: 'middleTraverseDate',
            datePicker: true,
        }, 
        {
            className: '',
            placeholder: '',
            id: 'work-order-middle-traverse-roll-code',
            name: 'middleTraverseRollCode',
            value: 'middleTraverseRollCode',
        }
    ], 
    [ 
        {
            className: '',
            placeholder: '',
            id: 'work-order-plain-support-date',
            name: 'plainSupportDate',
            value: 'plainSupportDate',
            datePicker: true,
        }, 
        {
            className: '',
            placeholder: '',
            id: 'work-order-plain-support-roll-code',
            name: 'plainSupportRollCode',
            value: 'plainSupportRollCode',
        }
    ], 
    [
        {
            className: '',
            placeholder: '',
            id: 'work-order-da1-date',
            name: 'da1Date',
            value: 'da1Date',
            datePicker: true,
        }, 
        {
            className: '',
            placeholder: '',
            id: 'work-order-da1-roll-code',
            name: 'da1RollCode',
            value: 'da1RollCode',
        }
    ], 
    [
        {
            className: '',
            placeholder: '',
            id: 'work-order-da2-date',
            name: 'da2Date',
            value: 'da2Date',
            datePicker: true,
        }, 
        {
            className: '',
            placeholder: '',
            id: 'work-order-da2-roll-code',
            name: 'da2RollCode',
            value: 'da2RollCode',
        }
    ], 
    [
        {
            className: '',
            placeholder: '',
            id: 'work-order-da3-date',
            name: 'da3Date',
            value: 'da3Date',
            datePicker: true,
        }, 
        {
            className: '',
            placeholder: '',
            id: 'work-order-da3-roll-code',
            name: 'da3RollCode',
            value: 'da3RollCode',
        }
    ], 
    [
        {
            className: '',
            placeholder: '',
            id: 'work-order-da4-date',
            name: 'da4Date',
            value: 'da4Date',
            datePicker: true,
        }, 
        {
            className: '',
            placeholder: '',
            id: 'work-order-da4-roll-code',
            name: 'da4RollCode',
            value: 'da4RollCode',
        }
    ], 
    [
        {
            className: '',
            placeholder: '',
            id: 'work-order-da5-date',
            name: 'da5Date',
            value: 'da5Date',
            datePicker: true,
        }, 
        {
            className: '',
            placeholder: '',
            id: 'work-order-da5-roll-code',
            name: 'da5RollCode',
            value: 'da5RollCode',
        }
    ], 
    [
        {
            className: '',
            placeholder: '',
            id: 'work-order-da6-date',
            name: 'da6Date',
            value: 'da6Date',
            datePicker: true,
        }, 
        {
            className: '',
            placeholder: '',
            id: 'work-order-da6-roll-code',
            name: 'da6RollCode',
            value: 'da6RollCode',
        }
    ]
]